<template>
  <div style="height: 100%;">
    <el-container style="height: 100%">
      <el-header v-if="headerType==1">
        <top />
      </el-header>
      <!-- 二级路由出口 -->
      <div class="router_container">
        <router-view />
      </div>
    </el-container>
  </div>
</template>

<script>
import top from '../../components/header/index.vue'
import { mapState } from 'vuex';
export default {
  components: { top },
  computed: {
    ...mapState(['examDetailed', 'userInfo'])
  },
  data() {
    return {
      headerType: 1
    }
  },
  watch: {
    '$route': { // $route可以用引号，也可以不用引号  监听的对象
      handler(val) {
        if (val.path === '/home/play') {
          this.headerType = 2;
        } else {
          this.headerType = 1;
        }
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true // 第一次初始化渲染就可以监听到
    }
  }
}
</script>

<style scoped>
  .el-header {
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.04);
  }
  .el-icon-switch-button{
    margin-right: 15px;
    color: #fff;
  }
  .title{
    font-size: 20px;
    font-weight: bold;
    color: #fff;
  }
  .router_container{
    height: 100%;
    background-color: #F7F8FA;
    overflow-y: auto;
  }
</style>
